import {Select} from "antd";
import React from "react";

interface Props {
    onChange?: (role:string) => void,
    value?: any,
    roles:string[]
    loading?:boolean,
}

function UserRoleSelect({onChange, value, roles, loading}: Props) {
    return (
        <Select size='large' value={value} onChange={onChange} style={{width:'100%'}} loading={loading}>
            {roles.map(role => <Select.Option key={role} value={role}>{role}</Select.Option>)}
        </Select>
    )
}

export default UserRoleSelect;